export const CHECK_TOKEN = 'oauth@CHECK_TOKEN';
export const checkToken = () => ({ type: CHECK_TOKEN });

export const DONE_CHECK_TOKEN = 'oauth@DONE_CHECK_TOKEN';
export const doneCheckToken = isValidToken => ({ type: DONE_CHECK_TOKEN, isValidToken });

export const CLEAR_CHECK_TOKEN = 'oauth@CLEAR_CHECK_TOKEN';
export const clearCheckToken = () => ({ type: CLEAR_CHECK_TOKEN });
